const NEWS_TITLE_SUFFIX = ' | Auckland Zoo News';
const SHORT_TITLE_SUFFIX = ' | Auckland Zoo';

/**
 * Normalize the page title for news article entities.
 *
 * @param {string} title Page title
 *
 * @return {string} Normalized title
 */
export default function normalizeNewsPageTitle(title) {
    if (!title || !title.endsWith(NEWS_TITLE_SUFFIX)) {
        return title;
    }

    return `${title.slice(0, -NEWS_TITLE_SUFFIX.length)}${SHORT_TITLE_SUFFIX}`;
}

/**
 * Adds the page number to a paginated listing title, keeping the brand suffix at
 * the end. Without this every page of a listing shares one title.
 *
 * @param {string} title Page title
 * @param {number} page Page number
 *
 * @return {string} Title including the page number
 */
export function appendPageNumber(title, page) {
    if (!title || !page || page < 2) {
        return title;
    }

    const pageLabel = ` – Page ${page}`;

    return title.endsWith(SHORT_TITLE_SUFFIX) ?
        `${title.slice(0, -SHORT_TITLE_SUFFIX.length)}${pageLabel}${SHORT_TITLE_SUFFIX}` :
        `${title}${pageLabel}`;
}
